// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../fe-workerportal/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#map[data-v-3b2bb14e]{height:100%;max-height:500px;min-height:400px}", ""]);
// Exports
module.exports = exports;
